import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/fields";
const fieldsApi = {
  getFields(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getRoleGroup(id: any): Promise<any> {
    const url = `${path}/${id}/role-groups`;
    return api.get(url);
  },
};

export default fieldsApi;
